document.addEventListener('DOMContentLoaded', () => {
  // Mobile Accordion
  const accordionHeadings = document.querySelectorAll('.premium-footer__column:not(.brand-col) .premium-footer__column-heading');
  
  accordionHeadings.forEach(heading => {
    heading.addEventListener('click', () => {
      if (window.innerWidth >= 750) return;
      
      const container = heading.nextElementSibling;
      const isOpen = heading.classList.contains('is-open');
      
      // Close all first if preferred, or allow multiple open
      // document.querySelectorAll('.premium-footer__column-heading.is-open').forEach(openHeading => {
      //   openHeading.classList.remove('is-open');
      //   openHeading.nextElementSibling.classList.remove('is-open');
      // });

      if (isOpen) {
        heading.classList.remove('is-open');
        container.classList.remove('is-open');
      } else {
        heading.classList.add('is-open');
        container.classList.add('is-open');
      }
    });
  });

  // Back to Top Button
  const backToTopBtn = document.querySelector('.premium-footer__back-to-top');
  if (backToTopBtn) {
    backToTopBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
  
  // Animation on scroll
  const footer = document.querySelector('.premium-footer.wj-animate-on-scroll');
  if (footer) {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    observer.observe(footer);
  }
});
